import ToolbarIcon from "../../../controls/ToolbarIcon";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import * as React from "react";
class ShowHiddenButton extends ComponentEx {
    render() {
        const { t, showHidden, toggleHidden } = this.props;
        return (React.createElement(ToolbarIcon, { id: "show-hidden-games", text: showHidden ? t("Hide Hidden Games") : t("Show Hidden Games"), onClick: toggleHidden, icon: showHidden ? "hide" : "show" }));
    }
}
export default translate(["common"])(connect()(ShowHiddenButton));
